// Drawer Logic
function toggleDrawer(id) {
    const drawer = document.getElementById(id);
    const overlay = document.getElementById('drawer-overlay');
    const isRight = id === 'drawer-search' || id === 'drawer-cart';
    const openClass = 'translate-x-0';
    const closeClass = isRight ? 'translate-x-full' : '-translate-x-full';

    if (drawer.classList.contains(openClass)) {
        drawer.classList.remove(openClass);
        drawer.classList.add(closeClass);
        overlay.classList.add('hidden');
        overlay.classList.remove('block', 'opacity-100');
        document.body.classList.remove('overflow-hidden');
    } else {
        // Close any open drawers first
        closeAllDrawers();
        drawer.classList.remove(closeClass);
        drawer.classList.add(openClass);
        overlay.classList.remove('hidden');
        setTimeout(() => overlay.classList.add('block', 'opacity-100'), 10);
        document.body.classList.add('overflow-hidden');
    }
}

function closeAllDrawers() {
    const drawers = ['drawer-menu', 'drawer-search', 'drawer-cart'];
    drawers.forEach(id => {
        const drawer = document.getElementById(id);
        const isRight = id === 'drawer-search' || id === 'drawer-cart';
        drawer.classList.remove('translate-x-0');
        drawer.classList.add(isRight ? 'translate-x-full' : '-translate-x-full');
    });
    const overlay = document.getElementById('drawer-overlay');
    if (overlay) {
        overlay.classList.add('hidden');
        overlay.classList.remove('block', 'opacity-100');
    }
    document.body.classList.remove('overflow-hidden');
}

// Header Scroll Logic
const header = document.getElementById('main-header');
const headerContents = document.querySelectorAll('.header-content');
const cartBadge = document.getElementById('cart-badge');

function updateHeader() {
    if (!header) return;
    const isHome = header.dataset.home === 'true';

    // If not home page, header is always opaque/scrolled
    if (!isHome) return;

    if (window.scrollY > 50) {
        header.classList.add('bg-white', 'border-outline-variant/30', 'scrolled');
        header.classList.remove('border-transparent');
        headerContents.forEach(el => {
            el.classList.add('text-primary');
            el.classList.remove('text-white');
        });
        if(cartBadge) {
            cartBadge.classList.add('bg-primary', 'text-white');
            cartBadge.classList.remove('bg-white', 'text-primary');
        }
    } else {
        header.classList.remove('bg-white', 'border-outline-variant/30', 'scrolled');
        header.classList.add('border-transparent');
        headerContents.forEach(el => {
            el.classList.remove('text-primary');
            el.classList.add('text-white');
        });
        if(cartBadge) {
            cartBadge.classList.remove('bg-primary', 'text-white');
            cartBadge.classList.add('bg-white', 'text-primary');
        }
    }
}

window.addEventListener('scroll', updateHeader);
updateHeader(); // Initialize

// Carousel Logic
const carousel = document.getElementById('product-carousel');
const prevBtn = document.getElementById('carousel-prev');
const nextBtn = document.getElementById('carousel-next');

if (carousel && prevBtn && nextBtn) {
    nextBtn.addEventListener('click', () => {
        const firstChild = carousel.querySelector('.group, div');
        if (!firstChild) return;
        const cardWidth = firstChild.offsetWidth + 24; // width + gap
        carousel.scrollBy({ left: cardWidth, behavior: 'smooth' });
    });

    prevBtn.addEventListener('click', () => {
        const firstChild = carousel.querySelector('.group, div');
        if (!firstChild) return;
        const cardWidth = firstChild.offsetWidth + 24; // width + gap
        carousel.scrollBy({ left: -cardWidth, behavior: 'smooth' });
    });
}

// Simple scroll parallax effect for images
window.addEventListener('scroll', () => {
    const scrolled = window.pageYOffset;
    const heroImg = document.querySelector('.hero-parallax-img');
    if (heroImg) {
        heroImg.style.transform = `translateY(${scrolled * 0.15}px)`;
    }
});

// Intersection Observer for fade-in animations
const observerOptions = {
    threshold: 0.1
};

const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('fade-in');
            observer.unobserve(entry.target);
        }
    });
}, observerOptions);

document.querySelectorAll('.fade-observer').forEach(el => {
    el.style.opacity = '0';
    observer.observe(el);
});

// Accordion Logic
function toggleAccordion(button) {
    const item = button.parentElement;
    const isActive = item.classList.contains('active');
    
    // Close all others in the same container
    item.parentElement.querySelectorAll('.accordion-item').forEach(el => {
        el.classList.remove('active');
    });

    if (!isActive) {
        item.classList.add('active');
    }
}

// Shopify Cart AJAX Logic
async function updateCartQty(btn, change, isRemove = false) {
    const id = btn.dataset.id;
    let newQty;

    if (isRemove) {
        newQty = 0;
    } else {
        const qtySpan = btn.parentElement.querySelector('.qty-value');
        if (!qtySpan) return;
        let currentQty = parseInt(qtySpan.textContent);
        newQty = currentQty + change;
    }
    
    if (newQty < 0) newQty = 0;

    btn.style.opacity = '0.5';
    btn.style.pointerEvents = 'none';

    try {
        await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: id, quantity: newQty })
        });
        await refreshCartDrawer();
        
        // If we are on the dedicated cart page, reload it to reflect changes
        if (window.location.pathname === '/cart') {
            window.location.reload();
        }
    } catch (error) {
        console.error('Error updating cart:', error);
    } finally {
        btn.style.opacity = '1';
        btn.style.pointerEvents = 'auto';
    }
}

async function refreshCartDrawer() {
    try {
        const response = await fetch('/?section_id=header');
        const text = await response.text();
        const html = new DOMParser().parseFromString(text, 'text/html');
        
        const newCartDrawer = html.getElementById('drawer-cart');
        const currentCartDrawer = document.getElementById('drawer-cart');
        if (newCartDrawer && currentCartDrawer) {
            currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
        }

        const newCartBadge = html.getElementById('cart-badge');
        const currentCartBadge = document.getElementById('cart-badge');
        if (newCartBadge && currentCartBadge) {
            currentCartBadge.innerHTML = newCartBadge.innerHTML;
        }
    } catch (error) {
        console.error('Error refreshing cart:', error);
    }
}

// Add to Cart Form Intercept
document.addEventListener('DOMContentLoaded', () => {
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
        productForm.addEventListener('submit', async (e) => {
            e.preventDefault();
            const submitBtn = productForm.querySelector('[type="submit"]');
            const originalText = submitBtn.textContent;
            submitBtn.textContent = 'ADDING...';
            submitBtn.disabled = true;

            try {
                const formData = new FormData(productForm);
                await fetch('/cart/add.js', {
                    method: 'POST',
                    body: formData
                });
                await refreshCartDrawer();
                toggleDrawer('drawer-cart');
            } catch (error) {
                console.error('Error adding to cart:', error);
                alert('Error adding item to cart.');
            } finally {
                submitBtn.textContent = originalText;
                submitBtn.disabled = false;
            }
        });
    }
});
